
import { ckTableStyles } from '../../../ckcore/ui/CkStyles';
import { Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material';
import { getPaymentStatusColor, getPaymentStatusText, getStatusColor, getTxStatusText, getTxTimeVN } from '../../../ckcore/core/TxUtils';
import User from '../../../ckcore/core/User';

export default function PurchaseRequestContactTable(props) {
  const tableStyles = ckTableStyles();
  const orderObj = props.orderObj;
  const cellBorder = { borderLeft: 1, borderColor: 'grey.300' };

  return (
    <TableContainer className={tableStyles.tableContainer}>

      <Table className={tableStyles.table} size="small" aria-label="trans list table" sx={{ borderTop: 1, borderRight: 1, borderColor: 'grey.300' }}>
        <TableBody>
        <TableRow className={tableStyles.row} style={{ height: 32 }}>
            <TableCell align="left" className={tableStyles.colHeader} sx={cellBorder}>
              <strong>Trạng thái:</strong> <span style={{ color: getStatusColor(orderObj.txStatusId) }}> {getTxStatusText(orderObj.txStatusId)}</span>
            </TableCell>
            <TableCell align="left" className={tableStyles.colHeader}>
              <strong>Thanh toán:</strong> <span style={{ color: getPaymentStatusColor(orderObj.paymentStatus) }}> {getPaymentStatusText(orderObj.paymentStatus)}</span></TableCell>
          </TableRow>
          <TableRow className={tableStyles.row} style={{ height: 32 }}>
            <TableCell align="left" className={tableStyles.colHeader} sx={cellBorder}><strong>Người yêu cầu:</strong> {orderObj.order.customer_name}</TableCell>
            <TableCell align="left" className={tableStyles.colHeader}><strong>SĐT:</strong> {User.getDisplayPhone(orderObj.order.customer_phone)}</TableCell>
          </TableRow>
          <TableRow className={tableStyles.row} style={{ height: 32 }}>
            <TableCell align="left" className={tableStyles.colHeader} sx={cellBorder}><strong>Người nhận yêu cầu:</strong> {orderObj.order.staff_name}</TableCell>
            <TableCell align="left" className={tableStyles.colHeader}><strong>SĐT:</strong> {User.getDisplayPhone(orderObj.order.staff_phone)}</TableCell>
          </TableRow>
          <TableRow className={tableStyles.row} style={{ height: 32 }}>
            <TableCell colSpan={2} align="left" className={tableStyles.colHeader} sx={cellBorder}><strong>Số tài khoản Quỹ:</strong> {orderObj.order.debit_account_number} - {orderObj.order.debit_bank_name}</TableCell>
          </TableRow>
          <TableRow className={tableStyles.row} style={{ height: 32 }}>
            <TableCell align="left" className={tableStyles.colHeader} sx={cellBorder}><strong>Nội dung CK:</strong> {orderObj.order.order_info}</TableCell>
            <TableCell align="left" className={tableStyles.colHeader}><strong>Thời gian:</strong> {getTxTimeVN(orderObj.created)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>

  );
}